<template>
    <div class="h-100">
        <h1 class="text-center mt-4 d-none d-lg-block">Bienvenido al sistema de facturaci&oacute;n en l&iacute;nea <br> de CASA AHUED SA
            DE CV
        </h1>
        <h4 class="text-center mt-4 d-lg-none">Bienvenido al sistema de facturaci&oacute;n en l&iacute;nea <br> de CASA AHUED SA
            DE CV
        </h4>
        <div class="card mt-lg-5 mt-3">
            <div class="card-header text-center bg-navi text-white h5">
                <b-icon icon="info-circle"></b-icon>
                Ponemos a su disposici&oacute;n nuestro portal en l&iacute;nea para agilizar el proceso de facturaci&oacute;n
            </div>
            <div class="card-body px-md-5 py-4">
                <p class="card-text"> Estimado cliente, atendiendo los cambios solicitados por las autoridades en este portal se emiten facturas con versi&oacute;n de CFDI 4.0
                Favor de tomar en cuenta los siguientes puntos:</p>

                <ul>
                    <li>Datos requeridos:
                        <ul>
                            <li>RFC</li>
                            <li>Nombre completo o Raz&oacute;n Social "EN MAYUSCULAS" (tal como aparece en su constancia de situaci&oacute;n fiscal)</li>
                            <li>C&oacute;digo postal (tal como aparece en su constancia de situaci&oacute;n fiscal)</li>
                            <li>R&eacute;gimen fiscal</li>
                        </ul>
                    </li>
                    <li>Solo se permitir&aacute;n facturar notas de venta emitidos dentro del mismo mes.</li>
                    <li>En caso de requerir cancelaci&oacute;n de su factura, favor de comunicarse con el depto. de contabilidad.</li>
                </ul>
                <p class="card-text">
                    Gracias!
                </p>
                <p class="card-text">
                    Depto. de contabilidad<br>
                    2288171266 ext. 1003<br>
                    contabilidad@casaahued.com
                </p>
                <router-link tag="a" :to="{ name: 'Invoice' }" class="btn btn-orange">
                    <b>Facturar</b>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Start',
        // mounted() {
        //     this.$store.dispatch('init/setInitHttp');
        // }
    }
</script>
